import { createFileRoute } from '@tanstack/react-router';

import { requireAuth } from '@apple/features/auth/utils/require-auth';

// TODO: Move `ManageLayout` to this file (need to figure out `ManageBreadcrumbs` first)
export const Route = createFileRoute('/_authed/_admin/manage')({
	beforeLoad: args =>
		requireAuth(args, {
			requirePermission: 'Manzanita.Security.Features.Snapshot',
		}),
});
